import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {Card, Col, Row} from 'antd';
import './Login.css';
import {injectIntl} from "react-intl";
import appTeaserBmw from "../../img/login-app-teaser-bmw-v2.png";
import appTeaserMini from "../../img/login-app-teaser-mini-v2.jpg";
import appStoreBadge from '../../img/app-store-badge.svg';
import googlePlayBadge from '../../img/google-play-badge.svg';
import qrcodeBmwBe from '../../img/qrcode_bmw_be.png';
import qrcodeBmwLu from '../../img/qrcode_bmw_lu.png';
import qrcodeMiniBe from '../../img/qrcode_mini_be.svg';
import qrcodeMiniLu from '../../img/qrcode_mini_lu.svg';
import {SpinnerModal} from '../components/SpinnerModal';
import Storage from "../../services/Storage";
import SAButton from "../../components/common/button/SAButton";
import MarketUtil from "../../services/MarketUtil";
import uuid from 'uuid/v4';
import TokenReceiver from "./TokenReceiver";
import BrandUtil from "../../services/BrandUtil";
import LoginForm from './LoginForm';

class Login extends Component {


  handleLogin = (username, password) => {
    this.props.dispatchCustomerLogin({username, password});
  };

  goto = (location) => {
    const {frontendConfig} = this.props;
    const lg = frontendConfig.environment && frontendConfig.environment === "PRODUCTION" ? Storage.getItem('lg') : 'nl'; // dirty fix to be able to register customer on TEST environment
    const market = MarketUtil.resolveMarket().marketCode;
    const brand = BrandUtil.resolveBrand().toLowerCase();
    const loginUUID = frontendConfig.environment && frontendConfig.environment === "PRODUCTION" ? uuid() : "18c41fec-2d92-4ce7-b621-8185f1388a20"; // dirty fix to be able to register customer on TEST environment
    Storage.setItem('login-uuid', loginUUID);
    let redirectUri = window.location.origin + '/public/token-receiver';
    if (redirectUri.includes('localhost')) {
      redirectUri = `${frontendConfig['oauth-redirect-uri'] || 'https://test.serviceapp.fleetback.com'}/public/token-receiver`
    }
    window.location = `${location}&country=${market}&language=${lg}&brand=${brand}&state=${loginUUID}&redirect_uri=${redirectUri}`
  };

  getQrCode(brand, market) {
    if (brand === 'mini') {
      return market === 'lu' ? qrcodeMiniLu : qrcodeMiniBe;
    }
    return market === 'lu' ? qrcodeBmwLu : qrcodeBmwBe
  }

  render() {
    const {intl: {formatMessage}, frontendConfig} = this.props;
    const {error, userState, loading} = this.props.authentication;

    const brand = BrandUtil.resolveBrand().toLowerCase();
    const market = MarketUtil.resolveMarket().marketCode.toLowerCase();
    const appStoreLink = `https://apps.apple.com/${market}/app/${brand === 'mini' ? 'mini/id1519459056' : 'my-bmw/id1519034860'}`;
    const googlePlayLink = `https://play.google.com/store/apps/details?id=de.${brand === "mini" ? "mini" : "bmw"}.connected.mobile20.row&gl=${market}`;
    const qrCode = this.getQrCode(brand, market);

    const host = window.location.host.split('.').pop().toLowerCase();
    const locale = Storage.getItem('lg') || "en";

    if (userState == 'signed-in') {
      return (
        <Redirect to={'/public/home'}/>
      )
    }

    return (
      <React.Fragment>
        <h4 style={{
          textAlign: 'center',
          width: '100%',
          fontSize: '3rem',
          paddingTop: '15px'
        }}>{formatMessage({id: `cui.home.title.${brand.toUpperCase()}`}).toUpperCase()}</h4>
        <SpinnerModal visible={loading}/>
        <Row className={"login"} gutter={32} type={"flex"}>
          <Col span={6} xs={24} sm={24} md={24} lg={24} xl={6} xxl={6}>
            <Card className="login-card">
              <h2>{formatMessage({id: 'cui.home.login.title'}).toUpperCase()}</h2>
              <p>
                {formatMessage({id: 'cui.home.login.description'})}
              </p>
              {frontendConfig['one-login'] === true &&
                <SAButton
                  type="primary"
                  onClick={() => this.goto(frontendConfig['login-url'])}>
                  {formatMessage({id: 'cui.home.login.login-button'})}
                </SAButton>
              }
              {frontendConfig['one-login'] === false &&
                <LoginForm
                  onSubmit={this.handleLogin}
                  isSubmitting={loading}
                  backendError={error}/>
              }
            </Card>
          </Col>
          <Col span={6} xs={24} sm={24} md={24} lg={24} xl={6} xxl={6}>
            <Card className="login-card">
              <h2>{formatMessage({id: 'cui.home.register.title'}).toUpperCase()}</h2>
              <p>
                {formatMessage({id: `cui.home.register.description.${brand.toUpperCase()}`})}
              </p>
              <SAButton
                type="primary"
                onClick={() => this.goto(frontendConfig['register-url'])}>
                {formatMessage({id: 'cui.home.register.register-button'})}
              </SAButton>
            </Card>
          </Col>
          <Col span={12} xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <Card className="login-card">
              <h2>{formatMessage({id: 'cui.home.teaser.title'}).toUpperCase()}</h2>
              <h2>{formatMessage({id: `cui.home.teaser.subtitle.${brand.toUpperCase()}`})}</h2>
              <Row gutter={16}>
                <Col span={8} xs={24} sm={24} md={24} lg={24} xl={8} xxl={8}>
                  <img src={brand === 'mini' ? appTeaserMini : appTeaserBmw} className={"app-teaser"}/>
                </Col>
                <Col span={16} xs={24} sm={24} md={24} lg={24} xl={16} xxl={16}>
                  <ul style={{paddingLeft: '15px'}}>
                    <li>{formatMessage({id: 'cui.home.teaser.description.item1'})}</li>
                    <li>{formatMessage({id: 'cui.home.teaser.description.item2'})}</li>
                    <li>{formatMessage({id: 'cui.home.teaser.description.item3'})}</li>
                    <li>{formatMessage({id: 'cui.home.teaser.description.item4'})}</li>
                    <li>{formatMessage({id: 'cui.home.teaser.description.item5'})}</li>
                  </ul>
                  <Row gutter={16} justify="space-between">
                    <Col span={12}>
                      <img className={"qr-code"} src={qrCode}/><br/>
                      <a href={googlePlayLink}>
                        <img className={"app-badge"} src={googlePlayBadge}/>
                      </a>
                    </Col>
                    <Col span={12}>
                      <img className={"qr-code"} src={qrCode}/><br/>
                      <a href={appStoreLink}>
                        <img className={"app-badge"} src={appStoreBadge}/>
                      </a>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>

        </Row>
        {frontendConfig.environment && frontendConfig.environment === "PRODUCTION" &&
          <footer style={{paddingLeft: '16px', paddingRight: '16px'}} className="customer-main" tabIndex="-1">
            <Row type="flex" justify="end" align="middle">
              <Col>
                <a style={{color: "black"}} href={frontendConfig[`dsa-${brand}-${host}`][locale]}
                   target="_blank">DSA</a>
              </Col>
            </Row>
          </footer>
        }
        <TokenReceiver/>
      </React.Fragment>

    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchCustomerLogin: payload => dispatch({type: 'FETCH.CUSTOMER_LOGIN.REQUEST', payload}),
});

const mapStateToProps = state => ({
  authentication: state.authentication,
  frontendConfig: state.frontendConfig,
  brand: state.publicContext && state.publicContext.brand,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);



// WEBPACK FOOTER //
// ./src/public/login/Login.js